module.exports = __webpack_public_path__ + "static/img/img2.ff49c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/double11/1/img2.png
// module id = 2p4P
// module chunks = 0